import {Types} from "../actions/createAccountActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';


import cleanDeep from 'clean-deep';


const defaultState = {
  leave: {}
};

const createAccountReducers = (state = defaultState, action) => {
  switch (action.type) {
    
    case Types.CREATE_ACCOUNT_DATA: {
      let newState = {...state}

      newState.createAccount.data = action.data

      return newState;
    }
    case Types.CREATE_ACCOUNT_CONTACT_LISTS: {
      let newState = {...state}

      newState.createAccount.inList = action.payload.lists
      newState.createAccount.webinars = action.payload.webinars

      return newState;
    }
    case Types.CREATE_ACCOUNT_SAVING_LEAD: {
      let newState = {...state}
      newState.createAccount.savingLead = true;

      const {noOfEmployees,organisation,name,surname,email} = action.data
      if(noOfEmployees){
        newState.createAccount.noOfEmployees = noOfEmployees;
      }
      if(organisation){
        newState.createAccount.organisation = organisation;
      }
      // user may not have an account hence we should save details for auto-fill on browser
      localStorage.setItem('userData',JSON.stringify(action.data))
      return newState;
    }
    case Types.CREATE_ACCOUNT_SAVED_LEAD: {
      let newState = {...state}
      newState.createAccount.savingLead = false;
      newState.createAccount.savedLead = true;

      let dealValue = 200

      switch (newState.createAccount.noOfEmployees){
          case "1-5":
          case "6-10":
              dealValue = 200;
              break
          case "11-20":
              dealValue = 500;
              break
          case "21-40":
              dealValue = 1000;
              break
          case "41-80":
              dealValue = 2000;
              break
          case "81-200":
              dealValue = 4000;
              break
          case "200+":
              dealValue = 4000;
              break
          default:
              if(!isNaN(newState.createAccount.noOfEmployees)){
                  // estimated value don't feel like rounding if this ends up exact
                  dealValue = newState.createAccount.noOfEmployees * 12
              }
      }

      window.gtag('event', 'generate_lead', {
        'event_category' : 'engagement',
        'event_label' : action.label
      });

      ReactPixel.track('Lead',{
        currency: "EUR",
        value: dealValue,
        content_name: action.label
        // predicted_ltv: dealValue * 3,
      });

      return newState;
    }


    case Types.CREATE_ACCOUNT_CREATING: {
      let newState = {...state}
      newState.createAccount.creating = true;
      newState.createAccount.noOfEmployees = action.noOfEmployees;
      newState.createAccount.organisation = action.organisation;
      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_CREATED: {
      let newState = {...state}
      newState.my.profile = action.payload.profile

      localStorage.setItem('userData',JSON.stringify(action.payload.profile))

      newState.createAccount.userCreated = true;

      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }

      let dealValue = 200

      switch (newState.createAccount.noOfEmployees){
          case "1-5":
          case "6-10":
              dealValue = 200;
              break
          case "11-20":
              dealValue = 500;
              break
          case "21-40":
              dealValue = 1000;
              break
          case "41-80":
              dealValue = 2000;
              break
          case "81-200":
              dealValue = 4000;
              break
          case "200+":
              dealValue = 4000;
              break
          default:
              if(!isNaN(newState.createAccount.noOfEmployees)){
                  // estimated value don't feel like rounding if this ends up exact
                  dealValue = newState.createAccount.noOfEmployees * 12
              }
      }

      window.gtag('event', 'sign_up', {
        'event_category' : 'engagement',
        'event_label' : 'email'
      });


      
      ReactPixel.track('StartTrial',{
        currency: "EUR",
        value: dealValue,
        predicted_ltv: dealValue * 3,
      });

      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_UPDATED: {
      let newState = {...state}
      newState.createAccount.userUpdated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }
      return newState;
    }
    case Types.CREATE_ACCOUNT_AC_LEAD: {
      let newState = {...state}
      newState.createAccount.acLeadCreated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }
      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_CREATION_FAILED: {
      let newState = {...state}
      newState.createAccount.creating = false;
      newState.createAccount.error = action.error;
      return newState;

    }
    case Types.CREATE_ACCOUNT_DEMO_CREATED: {
      let newState = {...state}
      newState.createAccount.demoAccountCreated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }
      return newState;

    }

    default:
      return state;
  }
};

export default createAccountReducers;